import RequestList from './RequestList';
import {Provider} from './RequestContext';

export const Requests = () => {
  return (
    <Provider>
      <RequestList />
    </Provider>
  );
};
